export default __webpack_public_path__ + "static/media/black-marker.953d3c77.svg";